module.exports = __webpack_public_path__ + "img/innovacion.0bfa0e4c.jpg";